import React, { useState, useEffect, useCallback } from "react";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import { Card, CircularProgress } from "@mui/material";
import { callAPI } from "../../../../axios";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";
import { debounce } from 'lodash';
import { getChainIdLS } from "../../../../utils/utils";
import dayjs from "dayjs";

function APKVersionDashboard() {
  const [apkMappingList, setApkMappingList] = useState([]);
  const [loader, setLoader] = useState(false);

  const recordsPerPage = 10;

  const { chainId } = useSelector((state) => state.chainIdReducer);
  const { viewType } = useSelector((state) => state.viewTypeReducer);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)


  const [searchText, setSearchText] = useState("")
  const [fromApkVersion, setFromApkVersion] = useState([])
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [searchTextValidation, setSearchTextValidation] = useState("");
  const [apkVersionFilter, setApkVersionFilter] = useState("All")

  const fromVersionApi = () =>{
      callAPI('/hotel/apk/fromVersion', "GET", {}, { chainId: getChainIdLS() })
      .then((response) => {
        const temp = [{apkVersion: "All", count: response?.reduce((acc,data)=>data.count+acc,0), key: "All"}]
        temp.push(...response?.map((data)=>({...data,key:data?.apkVersion?data?.apkVersion:"N.A"})))
        setFromApkVersion(viewType==='custom'?[{key: "All",count: "N.A"}]:temp)
      })
      .catch((err) => console.warn(err.message));
  }

  useEffect(() => {
    fromVersionApi()
    setSearchText("")
    setDebouncedSearchText("")
  }, [chainId]);

  const hotelListApi = () => {
    setLoader(true);
    const baseUrl = `/hotel/apk-mapping?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}&cdsn=${searchText ? searchText : ''}&apkVersion=${apkVersionFilter}`;
           
    callAPI(baseUrl, "GET", {}, { chainId: getChainIdLS() })
        .then((response) => {
            setApkMappingList(response?.cdsnApkResponses);
            setTotalPageCount(response?.totalPages ? response?.totalPages : 1);
            setPaginationError("");
            setLoader(false);
        })
        .catch((err) => {
            console.warn(err.message);
              setLoader(false);
        });
  };

  useEffect(() => {
    hotelListApi();
  }, [selectedPage, chainId, debouncedSearchText, apkVersionFilter]);

  useEffect(() => {
    setInputPageValue(1)
    setPaginationError("")
    setSelectedPage(1);
  }, [searchText, apkVersionFilter]);

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const columns = [    
      { field: "modifiedOn", headerName: "Modified On", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{dayjs(row.modifiedOn).format("DD MMM YYYY | HH:mm")}</p>  },
      { field: "modifiedBy", headerName: "Modified By", flex: 1 },
      { field: "cdsn", headerName: "CDSN's", flex: 1 },
      { field: "roomNo", headerName: "Room No", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{row.roomNo?row.roomNo:"N.A"}</p> },
      { field: "apkVersion", headerName: "Apk Version", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{row.apkVersion?row.apkVersion:"N.A"}</p> },
    ];

  // Handle immediate input change for visual feedback
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value); // Update immediately for UI responsiveness
        delayedSearch(value); // Trigger debounced validation
    };

    // Debounced function that updates the debounced state
    const delayedSearch = useCallback(
        debounce((value) => {
            if (/^\d*$/.test(value)) {
                setDebouncedSearchText(value); // Only update debounced value when valid
                setSearchTextValidation("");
            } else {
                setSearchTextValidation("Please Enter Numbers Only");
            }
        }, 600),
        []
    );

  return (
    <>
      <p className="mb-1 ms-1"><b>APK Version Dashboard</b></p>
      <div className="hotel-dashboard ms-1">
        {fromApkVersion?.map((data)=>{
          return (
          <Card className={`cursor-pointer ${apkVersionFilter == data?.key ? "activeHotelFilter" : ""}`} onClick={() => setApkVersionFilter(data?.key)}>
            <strong>Apk Version : {data?.key}</strong>
            <p>Count: {data?.count}</p>
          </Card>
          )
        })}
      </div>
      <div className='row config-hotel'>
        <div className='col-12 left-column'>
          {loader && <div className="circular-progress"><CircularProgress /></div>}
          <div className="hotel-list">
            <div className="flex-items-between mb-3">
              <p className="mb-0"><b>CDSN's List</b></p>
              <div className="d-flex">
              <div className="form-group-hotel mb-0">
                  <div className={`floating-label`}>
                      <input
                          id="searchCdsn"
                          maxLength={10}
                          placeholder=""
                          value={searchText}
                          className="form-control"
                          onChange={handleInputChange}
                      />
                      <label htmlFor="guestName">Search CDSN...</label>
                  </div>
                  {searchTextValidation && (
                      <small className="required">{searchTextValidation}</small>
                  )}
              </div>
              </div>
            </div>
            <TableWrapper
              data={viewType==='custom'?[]:apkMappingList}
              columns={columns}
              module=""
              noPagination={true}
            />
            <Custom_Paingation
              selectedPage={selectedPage}
              totalPageCount={totalPageCount}
              paginationError={paginationError}
              inputPageValue={inputPageValue}
              setSelectedPage={setSelectedPage}
              setPaginationError={setPaginationError}
              setInputPageValue={setInputPageValue}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default APKVersionDashboard;